import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import styles from './Menu.module.css';
import icon_cadastrar_servico from "../../img/icon_cadastrar_servico.svg";
import icon_cadastro_funcionario from "../../img/icon_cadastro_funcionario.svg";
import icon_editar_perfil from "../../img/icon_editar_perfil.svg";
import icon_inativar_funcionario from "../../img/icon_inativar_funcionario.svg";
import icon_dashboard from "../../img/icon_dashboard.svg"
import icon_sair from "../../img/icone_sair.png";
import { useDataManagement } from "../ferramentas/RequisitarAPI.ts";

const Menu = ({ accessLevel = "", className = "", layout = "default", onAction }) => {
  const navigate = useNavigate();
  const { logout } = useDataManagement();

  const [itemSelecionado, setItemSelecionado] = useState('');

  // Função auxiliar para lidar com todas as ações do menu
  const handleAction = (id, action) => {
    setItemSelecionado(id);

    // Emite evento personalizado para ser capturado pelo CalendarioApp
    if (action) {
      const event = new CustomEvent('menuAction', { detail: { action } });
      window.dispatchEvent(event);
    }

    // Notifica o componente pai que uma ação foi executada
    if (onAction) {
      onAction();
    }
  };

  // Funções para abrir modais
  const handleServicoClick = () => {
    handleAction('cadastrar_servico', 'servico');
  };

  const handleUsuarioClick = () => {
    handleAction('cadastrar_funcionario', 'usuario');
  };

  const handlePerfilClick = () => {
    handleAction('editar_perfil', 'perfil');
  };

  const handleLogoutClick = () => {
    handleAction('sair');
    logout();
  };

  const handleCalendar = () => {
    navigate("/admin/calendario")
  }

  const handleDashboard = () => {
    navigate("/admin/dashboard")
  }

  const handleGerenciarClick = () => {
    handleAction('inativar_funcionario', 'inativar_funcionario');
  };

  const option = {
    "default": (
      <>
        <div
          className={`${styles.menuItem} ${itemSelecionado === 'cadastrar_servico' ? styles.selected : ''}`}
          onClick={handleServicoClick}
        >
          <img src={icon_cadastrar_servico} className={styles.menuIcon} title="Cadastrar Serviço" alt="Cadastra serviço" />
          <span className={styles.menuText}>Cadastrar Serviço</span>
        </div>

        { (accessLevel === "mod" || accessLevel === "admin") && (
          <div
              className={`${styles.menuItem} ${itemSelecionado === 'dashboard' ? styles.selected : ''}`}
              onClick={handleDashboard}
            >
              <img src={icon_dashboard} className={styles.menuIcon} title="Dashboard" alt="Dashboard" />
              <span className={styles.menuText}>Dashboard</span>
            </div>
        )}

        {accessLevel === "admin" && (
          <>
            <div
              className={`${styles.menuItem} ${itemSelecionado === 'cadastrar_funcionario' ? styles.selected : ''}`}
              onClick={handleUsuarioClick}
            >
              <img src={icon_cadastro_funcionario} className={styles.menuIcon} title="Cadastrar Funcionário" alt="Funcionário" />
              <span className={styles.menuText}>Cadastrar Funcionário</span>
            </div>

            <div
              className={`${styles.menuItem} ${itemSelecionado === 'cadastrar_funcionario' ? styles.selected : ''}`}
              onClick={handleGerenciarClick}
            >
              <img src={icon_inativar_funcionario} className={styles.menuIcon} title="Cadastrar Funcionário" alt="Funcionário" />
              <span className={styles.menuText}>Inativar Funcionário</span>
            </div>
          </>
        )}

        <div
          className={`${styles.menuItem} ${itemSelecionado === 'editar_perfil' ? styles.selected : ''}`}
          onClick={handlePerfilClick}
        >
          <img src={icon_editar_perfil} className={styles.menuIcon} title="Editar perfil" alt="Editar perfil" />
          <span className={styles.menuText}>Editar Perfil</span>
        </div>

      </>
    ),

    "dashboard": (
      <>
        <div
          className={`${styles.menuItem} ${itemSelecionado === 'voltar_calendario' ? styles.selected : ''}`}
          onClick={handleCalendar}
        >
          <img src={icon_cadastrar_servico} className={styles.menuIcon} title="Voltar para o calendario" alt="Voltar para o calendario" />
          <span className={styles.menuText}>Voltar para o calendario</span>
        </div>
      </>
    )
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.menuContainer}>
        <h2 className={styles.menuTitle}>Menu</h2>
        <hr className={styles.menuDivider} />
        <div className={styles.menuOptions}>
          {option[layout]}

          <hr className={styles.menuDivider} />

          <div className={styles.menuFooter}>
            <div
              className={`${styles.menuItem} ${itemSelecionado === 'logout' ? styles.selected : ''}`}
              onClick={handleLogoutClick}
            >
              <img src={icon_sair} className={styles.menuIcon} style={{ width: '24px', height: '24px' }} title="logout" alt="logout" />
              <span className={styles.menuText}>Logout</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;